module.exports = __webpack_public_path__ + "assets/9a72406739834ee2dfef50b03968172c.png";